const { setString } = require('../utils');
export default [
    {
        title: '文件名',
        type: 'string',
        dataIndex: 'name',
        key: 'name',
        width: '6%',
    },
    {
        title: '开始',
        type: 'boolean',
        dataIndex: 'missionStart',
        key: 'missionStart',
        render: (text) => text ? text.toString() : 'false',
        width: '5%',
        editable: true,
    },
    {
        title: '任务列表',
        type: 'string',
        dataIndex: 'todoList',
        key: 'todoList',
        render: (text) => setString(text),
        width: '38%',
    },
    {
        title: '完成进度',
        type: 'string',
        dataIndex: 'result',
        key: 'result',
        render: (text) => setString(text),
        width: '32%',
    },
    {
        title: '完成',
        type: 'boolean',
        dataIndex: 'missionComplete',
        key: 'missionComplete',
        render: (text) => text ? text.toString() : 'false',
        width: '5%',
        editable: true,
    },
];